<div class="mode-btn-container" (contextmenu)="$event.stopImmediatePropagation()">
  <button *ngFor="let config of modes" [class.mode-active]="config.active"
    [style.background]="config.active ?  (config.color ? config.color :'#517acc' )  : 'ffffff'"
    [class.mode-disabled]="config.disabled" (click)="toggleModeActive(config)" [title]="config.tooltip"
    [disabled]="config.disabled">
    <qpoint-icon [icon]="config.icon ?? (config.mode | mapModeIcon)"
      [iconType]="config.iconType ?? 'regular'"></qpoint-icon>
  </button>
</div>
